import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cp2005',
    ecrans: ['00-2', '01-2'],
    params: ["id"]
});
